<template>
  <div class="month-calendar">
    <div class="month-calendar__container">
      <v-calendar
        :attributes="attributes"
        is-expanded
        :is-dark="theme === 'dark'"
        locale="ru"
        :disabled-dates="disabledDates"
        title-position="right"
      >
        <card
          v-if="day.inMonth"
          :class="['mc-day-content', day.isToday ? 'today' : '']"
          slot="day-content"
          slot-scope="{ day }"
          dis-hover
          :padding="8"
        >
          <div class="mc-day-content__header ms-subhead">
            <span class="ms-subhead">
              {{ day.day }} {{ day.isToday ? "(сегодня)" : null }}
            </span>
            <div
              v-if="day.attributes && day.attributes.length"
              class="mc-day-content__modal-button ms-link"
              @click="dayClickHandler(day)"
            >
              <icon type="md-list" :size="18" />
            </div>
          </div>
          <ul class="mc-day-content__events" v-if="day.attributes">
            <event-item
              v-for="event in day.attributes"
              :key="event.key"
              :event="event"
            />
          </ul>
        </card>
      </v-calendar>
    </div>
    <modal
      :title="modalTitle"
      v-model="oneDayModal"
      width="560"
      :footer-hide="true"
    >
      <ul class="mc-day-content__events" v-if="oneDay && oneDay.attributes">
        <event-item
          v-for="event in oneDay.attributes"
          :key="event.key"
          :event="event"
        />
      </ul>
    </modal>
  </div>
</template>

<script>
import EventItem from '../tasks/event-item'
import { getStyleObject } from '../tools'

export default {
  props: ['tasks', 'holidays'],
  components: {
    EventItem
  },
  data () {
    return {
      oneDayModal: false,
      oneDay: null
    }
  },
  computed: {
    theme () {
      return this.$store.state.theme
    },
    disabledDates () {
      return this.holidays.map((d) => new Date(d))
    },
    attributes () {
      return [
        ...this.tasks.map((t) => ({
          key: t.id,
          contentStyle: {
            color: '#fafafa'
          },
          props: t,
          ...getStyleObject(t)
        }))
      ]
    },
    modalTitle () {
      if (!this.oneDay) return ''

      return this.oneDay.ariaLabel
    }
  },
  methods: {
    dayClickHandler (day) {
      this.oneDay = day
      this.oneDayModal = true
    }
  }
}
</script>

<style lang="less">
.month-calendar {
  .vc-container {
    width: 100%;
  }

  .vc-bg-white {
    background: #f5f7f9;
  }

  .mc-day-content {
    margin: 4px 2px;
    height: 180px;

    &.today {
      border-color: rgba(@primary-color, 1) !important;
    }

    .ivu-card-body {
      display: flex;
      flex-direction: column;
      height: 100%;
    }

    &__header {
      margin-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__modal-button {
      cursor: pointer;
    }

    &__events {
      flex: 1;
      overflow: auto;
      padding: 4px 0;
      padding-right: 4px;
    }
  }
}
</style>
